
































import { Component, Vue, Watch } from 'vue-property-decorator';

import AppRouteHeader from '@/components/AppRouteHeader/AppRouteHeader.vue';
import DownloadButton from '@/components/DownloadButton/DownloadButton.vue';
import ReleaseList from '@/components/ReleaseList/ReleaseList.vue';
import TimeoutError from '@/components/TimeoutError/TimeoutError.vue';

import NotFoundRoute from '@/views/NotFoundRoute.vue';

@Component({
  components: {
    AppRouteHeader,
    DownloadButton,
    NotFoundRoute,
    ReleaseList,
    TimeoutError,
  },
  metaInfo() {
    return {
      title: this.$data.title,
    };
  },
})
export default class Release extends Vue {
  loading = true;
  title: string = this.loading ? 'Loading...' : '';

  releases: AppStore.Release[] = [];
  latest: AppStore.Release | {} = {};

  error: Error | null = null;

  timer: number | null = null;
  timeElapsed = 0;
  SLOW_NETWORK_NOTIFICATION_THRESHOLD = 2500; /// * refers to half the time until axios timeout

  created(): void {
    this.loading = true;
    this.fetchReleaseData();
  }

  @Watch('$route')
  async fetchReleaseData(): Promise<void> {
    await this.fetchRouteData();
  }

  async reload(): Promise<void> {
    await this.fetchRouteData();
  }

  async fetchRouteData(): Promise<void> {
    this.timer = setInterval(() => {
      this.timeElapsed += 1;
    }, 1);

    const fetchedSlug = this.$route.params.slug;

    this.loading = true;
    this.title = 'Loading...';

    this.releases = [];
    this.latest = {};
    this.error = null;

    if (this.$route.params.slug !== fetchedSlug) {
      return;
    }

    if (window) {
      window.scrollTo(0, 0);
    }

    try {
      const token = await this.$auth.getTokenSilently({});

      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await this.$http.get<AppStore.SingleAppData>({
        url: `/?app=${this.$route.params.slug}`,
        options,
      });

      const { latest, releases } = data;

      this.latest = latest;
      this.releases = releases;

      this.title = latest.display_name;
    } catch (error) {
      this.error = error;
      this.title = 'An error occurred';

      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      clearInterval(this.timer);
      this.timer = null;
      this.timeElapsed = 0;
      this.loading = false;
    }
  }
}
